import Fetch from "./Fetch";

import { API_BASIC_URL_SLOT_SERVICE } from "../config/constants";
import { handleError, handleResponse } from "./ApiUtils";

export const fetchPOSAndServiceTypesCount = (data) => {
  return Fetch.get(`${API_BASIC_URL_SLOT_SERVICE}/api/v2/pos/count`, data).then(handleResponse).catch(handleError);
};

export const createCountrySettings = (countryId, data) => {
  return Fetch.create(`${API_BASIC_URL_SLOT_SERVICE}/api/v1/country/${countryId}`, data).then(handleResponse).catch(handleError);
};

export const fetchCountrySettings = (countryId) => {
  return Fetch.get(`${API_BASIC_URL_SLOT_SERVICE}/api/v1/country/${countryId}`).then(handleResponse).catch(handleError);
};

export const updateCountrySettings = (countryId, data) => {
  return Fetch.update(`${API_BASIC_URL_SLOT_SERVICE}/api/v1/country/${countryId}`, data).then(handleResponse).catch(handleError);
};
